import { render, staticRenderFns } from "./comp_FooterCertificates.vue?vue&type=template&id=f0176b36&scoped=true&"
import script from "./comp_FooterCertificates.vue?vue&type=script&lang=js&"
export * from "./comp_FooterCertificates.vue?vue&type=script&lang=js&"
import style0 from "./comp_FooterCertificates.vue?vue&type=style&index=0&id=f0176b36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0176b36",
  null
  
)

export default component.exports